import { render, staticRenderFns } from "./GroupInfoForm.vue?vue&type=template&id=5eca7730"
import script from "./GroupInfoForm.vue?vue&type=script&lang=js"
export * from "./GroupInfoForm.vue?vue&type=script&lang=js"
import style0 from "./GroupInfoForm.vue?vue&type=style&index=0&id=5eca7730&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports